import React from 'react';
import '../App.css';
export class Footerappprivateadmin extends React.Component {
    render() {
        return (
            <div className='sshfooterapp'>
            

            
            </div>
        );
    }
}